import { useSEO } from '@/hooks/useSEO';
import PageNavbar from "@/components/feature/PageNavbar";
import ServicesHero from "./components/ServicesHero";
import ServicesGrid from "./components/ServicesGrid";
import Footer from "@/pages/home/components/Footer";

const SITE_URL = (import.meta.env.VITE_SITE_URL as string) || 'https://isman.co.ke';

const SERVICES_SCHEMA = [
  {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    "name": "Engineering Services — ISMAN Company Kenya",
    "url": SITE_URL + "/services",
    "description": "Comprehensive industrial engineering services in Kenya: HVAC, industrial machinery, preventive maintenance, water treatment, food grade equipment, system automation and more.",
    "provider": {
      "@type": "LocalBusiness",
      "name": "ISMAN Engineering Company",
      "url": SITE_URL
    }
  },
  {
    "@context": "https://schema.org",
    "@type": "ItemList",
    "name": "ISMAN Engineering Services",
    "url": SITE_URL + "/services",
    "numberOfItems": 7,
    "itemListElement": [
      { "@type": "ListItem", "position": 1, "name": "Industrial Machinery Installation & Repair", "url": SITE_URL + "/services/industrial-machinery" },
      { "@type": "ListItem", "position": 2, "name": "Preventive Maintenance Programs", "url": SITE_URL + "/services/preventive-maintenance" },
      { "@type": "ListItem", "position": 3, "name": "Pneumatic & Hydraulic Systems", "url": SITE_URL + "/services/pneumatic-hydraulic" },
      { "@type": "ListItem", "position": 4, "name": "Structural Installation", "url": SITE_URL + "/services/structural-installation" },
      { "@type": "ListItem", "position": 5, "name": "Food Grade Equipment Installation", "url": SITE_URL + "/services/food-grade-equipment" },
      { "@type": "ListItem", "position": 6, "name": "Water Treatment Plant Installation", "url": SITE_URL + "/services/water-treatment" },
      { "@type": "ListItem", "position": 7, "name": "System Automation — PLC, SCADA & Dataloggers", "url": SITE_URL + "/services/system-automation" }
    ]
  },
  {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      { "@type": "ListItem", "position": 1, "name": "Home", "item": SITE_URL },
      { "@type": "ListItem", "position": 2, "name": "Services", "item": SITE_URL + "/services" }
    ]
  }
];

export default function ServicesPage() {
  useSEO({
    title: 'Engineering Services Kenya | ISMAN Company Nairobi — HVAC, Machinery, Automation',
    description: 'ISMAN Company offers 7 core industrial engineering services in Kenya: industrial machinery, HVAC, preventive maintenance, water treatment, food grade equipment, pneumatic systems and PLC automation.',
    keywords: 'engineering services Kenya, HVAC installation Kenya, industrial machinery Nairobi, water treatment Kenya, PLC automation Kenya, preventive maintenance Kenya',
    canonical: SITE_URL + '/services',
    schema: SERVICES_SCHEMA,
  });

  return (
    <div className="min-h-screen bg-white">
      <PageNavbar />
      <main className="pt-8">
        <ServicesHero />
        <ServicesGrid />
      </main>
      <Footer />
    </div>
  );
}
